import { Button, Checkbox, FormControlLabel, Grid, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { onError } from "src/store/actions/popupActions";
import axios from '../../../axios/AxiosInterceptors';
import { hasPermissionForAccount } from "../../../Utility/PermissionsUtil";
import { cleanStringInput } from "../../../Utility/StringUtil";

const MeterAccountComponent = (props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const roles = useSelector(state => state.auth.roles);
    const [meterAccount, setMeterAccount] = useState({ meterName: '', validatePowerMeterSubmissions: false });
    const [selectedGenerator, setSelectedGenerator] = useState({ id: 0, generatorName: '' });
    const [generators, setGenerators] = useState([{ id: 0, generatorName: '' }]);
    const [powerMeterIdOptions, setPowerMeterIdOptions] = useState([<MenuItem value='' key='default'></MenuItem>]);

    useEffect(() => {
        retrieveGenerators().then(response => {
            if (props.meterAccount) {
                setMeterAccount(props.meterAccount);
                if (response && response.data && response.data.length > 0) {
                    setGeneratorAndPowerMeterOptions(response.data);
                }
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const isDisabled = () => {
        return !hasPermissionForAccount(roles, Number(params.accountId), "ROLE_create_meter_account");
    }

    const retrieveGenerators = async () => {
        return await trackPromise(axios.get("/account-service/v1/account/" + params.accountId + "/generator").then(response => {
            if (response && response.data) {
                setGenerators([{ id: 0, generatorName: '' }, ...response.data]);
                return response;
            }
        }).catch(error => {
            dispatch(onError(error.response));
        }))
    }

    const setGeneratorAndPowerMeterOptions = (generators) => {
        const tempGen = generators.filter(r => r.id === props.meterAccount.generatorId)[0];
        setSelectedGenerator({ ...tempGen });
        generatePowerMeterIdSelections({ ...tempGen });
    }

    const handleGeneratorChange = (e, value) => {
        setSelectedGenerator(value);
        if (value && value.id && value.id !== 0) {
            meterAccount.generatorId = value.id;
        } else {
            meterAccount.generatorId = null;
            meterAccount.powerMeterId = null;
        }
        generatePowerMeterIdSelections(value);
        if (props.onChange) {
            props.onChange(meterAccount);
        }
    }

    const handleMeterNameChange = (e) => {
        meterAccount.meterName = e.target.value;
        setMeterAccount({ ...meterAccount });
        if (props.onChange) {
            props.onChange(meterAccount);
        }
    }

    const handleValidateMeterSubmissionChange = () => {
        meterAccount.validatePowerMeterSubmissions = !meterAccount.validatePowerMeterSubmissions;
        setMeterAccount({ ...meterAccount });
        if (props.onChange) {
            props.onChange(meterAccount);
        }
    }

    const saveMeterAccount = () => {
        if (props.saveMeterAccount) {
            props.saveMeterAccount(params.accountId, params.meterAccountId, meterAccount);
        }
    }

    const generatePowerMeterIdSelections = (value) => {
        if (!value) {
            setPowerMeterIdOptions([<MenuItem value='' key='default'></MenuItem>]);
        } else {
            const options = [<MenuItem value='' key='default'></MenuItem>];
            if (value.powerMeterId) {
                options.push(<MenuItem value={value.powerMeterId} key={value.powerMeterId}>{value.powerMeterId}</MenuItem>);
            }
            if (value.separateStationService && value.stationServicePowerMeterId) {
                options.push(<MenuItem value={value.stationServicePowerMeterId} key={value.stationServicePowerMeterId}>{value.stationServicePowerMeterId}</MenuItem>);
            }
            setPowerMeterIdOptions([...options]);
        }
    }

    const handlePowerMeterIdChange = (e) => {
        meterAccount.powerMeterId = e.target.value;
        setMeterAccount({ ...meterAccount });
        if (props.onChange) {
            props.onChange(meterAccount);
        }
    }

    const determinePowerMeterIdValue = (meterAccount) => {
        if (powerMeterIdOptions && powerMeterIdOptions.length > 1) {
            return meterAccount.powerMeterId ? meterAccount.powerMeterId : '';
        }
        return '';
    }

    return (
        <React.Fragment>
            {meterAccount && <Typography variant="h5" align="center">{meterAccount.meterName}</Typography>}
            <form onSubmit={(e) => {
                e.preventDefault();
                saveMeterAccount();
            }}>
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={1} />
                    <Grid item xs={6} sm={3}>
                        <TextField name="meterName" value={cleanStringInput(meterAccount.meterName)} label="Meter Name" onChange={handleMeterNameChange} fullWidth disabled={isDisabled()} />
                    </Grid>
                    <Grid item xs={6} sm={1} />
                    <Grid item xs={6} sm={3}>
                        <Autocomplete value={selectedGenerator} onChange={(e, value) => handleGeneratorChange(e, value)} options={generators} getOptionLabel={(option) => option.generatorName} renderInput={(params) => <TextField {...params} label="Generator" />}
                            getOptionSelected={(option, value) => option.id === value.id} disabled={isDisabled()} />
                    </Grid>
                    {selectedGenerator && selectedGenerator.id !== 0 &&
                        <React.Fragment>
                            <Grid item xs={6} sm={1} />
                            <Grid item xs={6} sm={3}>
                                <TextField value={determinePowerMeterIdValue(meterAccount)} select label="Power Meter Id" onChange={handlePowerMeterIdChange} fullWidth>
                                    {powerMeterIdOptions}
                                </TextField>
                            </Grid>
                        </React.Fragment>
                    }
                    <Grid item xs={6} sm={1} />
                    <Grid item xs={6} sm={3} align="center">
                        <FormControlLabel control={<Checkbox checked={meterAccount.validatePowerMeterSubmissions}
                            onChange={handleValidateMeterSubmissionChange} />} label="Validate Meter Submissions" disabled={isDisabled()} />
                    </Grid>
                    <Grid item xs={6} sm={8} />
                    <Grid item xs={6} sm={4} />
                    <Grid item xs={6} sm={4} align="center">
                        {!isDisabled() && <Button type="submit">Save</Button>}
                    </Grid>
                    <Grid item xs={6} sm={4} />
                </Grid>
            </form>
        </React.Fragment>
    )

}

export default MeterAccountComponent;